import { render, staticRenderFns } from "./orderListAdmin.vue?vue&type=template&id=36b438c4&scoped=true"
import script from "./orderListAdmin.vue?vue&type=script&lang=js"
export * from "./orderListAdmin.vue?vue&type=script&lang=js"
import style0 from "./orderListAdmin.vue?vue&type=style&index=0&id=36b438c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b438c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b438c4')) {
      api.createRecord('36b438c4', component.options)
    } else {
      api.reload('36b438c4', component.options)
    }
    module.hot.accept("./orderListAdmin.vue?vue&type=template&id=36b438c4&scoped=true", function () {
      api.rerender('36b438c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderListAdmin.vue"
export default component.exports